import styled from 'styled-components';

export const Field = styled.div`
  margin-top: 10px;
  > label {
    margin-bottom: 5px;
    display: flex;
  }
`;
